import { render, staticRenderFns } from "./CreateNewRevision.vue?vue&type=template&id=04bec316"
import script from "./CreateNewRevision.vue?vue&type=script&lang=js"
export * from "./CreateNewRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports